








































import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyList from "@/mixins/list";

import AddStadium from "@/views/stadium/add.vue";
import EditStadium from "@/views/stadium/modal.vue";

@Component({
  components: {
    AddStadium,
    EditStadium
  }
})
export default class extends Mixins(MyList) {
  @Prop() customerId!: number;

  dispatchType = "customer/stadiums";

  addStadiumVisible = false;

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    { title: "场馆名称", dataIndex: "name" },
    { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  showAddStadiumModal() {
    this.addStadiumVisible = true;
  }

  hideAddStadiumModal() {
    this.addStadiumVisible = false;
    this.loadData(
      {
        customer_id: this.customerId
      },
      false
    );
  }

  mounted() {
    this.loadData(
      {
        customer_id: this.customerId
      },
      false
    );
  }
}
